// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Variant_doneButton__YTxAh {
    background: #105293;
    color: white;
    width: 100px;
}

.Variant_tablecellBox__1z2-j{
    
    width: 100px;
}

.Variant_variantAddBtn__9zQfT{
    border: none;
    padding: 2px 10px;
    border-radius: 10px;
    margin-left: 10px;
    font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/components/Variants/Variant.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;AAChB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;AACpB","sourcesContent":[".doneButton {\n    background: #105293;\n    color: white;\n    width: 100px;\n}\n\n.tablecellBox{\n    \n    width: 100px;\n}\n\n.variantAddBtn{\n    border: none;\n    padding: 2px 10px;\n    border-radius: 10px;\n    margin-left: 10px;\n    font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"doneButton": `Variant_doneButton__YTxAh`,
	"tablecellBox": `Variant_tablecellBox__1z2-j`,
	"variantAddBtn": `Variant_variantAddBtn__9zQfT`
};
export default ___CSS_LOADER_EXPORT___;
